export default {
  path: '/authManage',
  name: '',
  component: () => import('@/components/layout/layout.vue'),
  redirect: '/authManage/home',
  children: [
    {
      path: 'index',
      name: 'authManage_index',
      component: () => import('./index')
    },{
      path: 'roleManage',
      name: 'roleManage',
      component: () => import('./roleManage/index.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/pages/authManage/router_authManage.js